import axios from 'axios';
import { req } from './axiosFun';

/**
 * 景点管理
 **/
// 获取景点列表
export const campList = (params) => { return axios.get("/customer/listChaosInfo2?page=" + params.currentPage + "&pageSize=" + params.pageSize + "&status=1&pageIndex=" + params.currentPage) };
export const campListSave  = (params) => { return req("post", "/customer/addChaosInfo2", params) };
export const campListDel  = (params) => { return req("post", "/customer/deleteChaosInfo2", params) };






// WEBPACK FOOTER //
// ./src/api/campsMG13.js